import React from "react";

// The reasons deals actually get pulled for. Wording is written to be read by the shop owner,
// because whatever is picked here is what lands in their inbox.
export const ARCHIVE_REASONS = [
  "The price looks wrong or misleading",
  "The photo doesn't match the offer",
  "The photo is too blurry or unclear to use",
  "This isn't a real discount",
  "It's already over or out of stock",
  "It duplicates another live deal",
  "It's in the wrong category",
  "The terms aren't clear enough",
  "The content isn't suitable for LytePress",
];

// One-tap reasons. Tapping toggles a reason in and out of the message the shop receives, and the
// admin can still type anything extra underneath.
export const ArchiveReasonPicker = ({ picked, onToggle, testidPrefix = "archive-reason" }) => (
  <div className="flex flex-wrap gap-1.5">
    {ARCHIVE_REASONS.map((r) => {
      const on = picked.includes(r);
      return (
        <button key={r} type="button" onClick={() => onToggle(r)} data-testid={`${testidPrefix}-${ARCHIVE_REASONS.indexOf(r)}`}
          className={`text-[11px] font-semibold px-2.5 py-1.5 rounded-full border text-left transition-colors ${on ? "border-rose-400 bg-rose-50 dark:bg-rose-950/30 text-rose-600" : "border-border text-muted-foreground hover:bg-secondary"}`}>
          {r}
        </button>
      );
    })}
  </div>
);

const dot = (s) => (/[.!?]$/.test(s.trim()) ? s.trim() : `${s.trim()}.`);

export const composeReason = (picked, extra) =>
  [...picked.map(dot), (extra || "").trim()].filter(Boolean).join(" ").slice(0, 400);

export default ArchiveReasonPicker;
